module.exports = __webpack_public_path__ + "img/tongue-test.cb98f77d.png";